import React from 'react';
import VBLeaflet from "@vb-js-commons/new/vbLeaflet";
import { LayerSelector, ZoomAndLayerButtons } from '../../../components/mapComponents/MapComponents';
import txt from './txt';

class NHLeaflet extends React.Component {
    constructor(props) {
        super(props);

        this.map = React.createRef();

        this.state={
            mapTools:false,
        }
        this.drawnItems = L.featureGroup([]);
    }

    componentDidMount(){
        if(this.props.geojson){
            const timeout = setTimeout(() => {
                if(this.map.current.state.map){
                    this.addGeojsonToMap(this.props.geojson, "#FFFFFF", "transparent", false)
                    this.props.sections.map((sect) => {
                        let layr = this.addGeojsonToMap(sect.geom, sect.geom_color ? sect.geom_color : "#03A086");

                        layr.on("click", () => {this.props.handleSectionClick(sect.id)})
                    })
                    //this.map.current.setLegendData(this.props.sections.map((sect) => {return {"color": sect.geom_color ? sect.geom_color : "#03A086", "label": sect.name}}), "", []);
                    
                    clearTimeout(timeout);
                }
            }, 50)
        }
    }

    addGeojsonToMap(geojson, color, fillColor, addToDrawn=true) {
        
        let style = {color:color}
        if (fillColor){
            style.fillColor = fillColor
        }
        let layr = L.geoJSON(geojson, style)
        this.drawnItems.addLayer(layr)
        this.map.current.setLayers(this.drawnItems)
        this.drawnItems.addTo(this.map.current.state.map)
        this.map.current.state.map.fitBounds(this.drawnItems.getBounds());
      
        return layr
        
    }

    render() {
        return (<div className="position-relative w-100 h-100">  
                    <VBLeaflet ref={this.map} id="nhleaflet_map" baseMap="Mapbox Satelite" />
                    <ZoomAndLayerButtons mapRef = {this.map} mapTools={this.state.mapTools} setMapTools = {(val)=>{this.setState({mapTools:val})}} />
                    {this.state.mapTools && <LayerSelector mapRef = {this.map} mapTools={this.state.mapTools} setMapTools = {(val)=>{this.setState({mapTools:val})}} setRefresh={(val)=>this.setState({refresh:val})}/>}
                    
                    {this.props.sections.length > 0 ? <div className="bg-white no-scroll-bar position-absolute bottom-0 end-0 mb-5 me-2 p-2 corners-1-all" style={{zIndex:400, maxHeight:"150px", overflowY:"auto"}}>
                        {this.props.sections.map((sect) => {
                        return <div className="d-flex align-items-center justify-content-start n-fs-7 my-1">
                            <div className="me-1 corners-1-all" style={{width:"16px", height:"16px", background:sect.geom_color ? sect.geom_color : "#03A086"}}></div>
                            {txt({location_id:`ProjectForestSection_name_${sect.id}`, context_clue:"biodiversity project forest section name", text:sect.name})}
                        </div>
                        })}
                    </div>:null}
                    </div>
        )
    }
}
export default NHLeaflet;